import services from "@/http";
import * as types from "./mutation-types";
import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty";
import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty";

export const ActionGetAll = async ({ dispatch }, payload = {}) => {
  if (typeof payload === "object") payload.incluir_sem_oportunidade = true;

  const data = await dispatch("ActionFind", payload);
  dispatch("ActionSetConcedentes", data.data);
  dispatch("ActionSetPagination", data.meta);

  return data;
};

export const ActionFind = async (store, search) => {
  try {
    const { data } = await services.concedentes.get_all(search);

    return data;
  } catch (error) {
    return {
      data: [],
      meta: {},
    };
  }
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.concedentes.show({ id: id }).then((res) => {
    dispatch("ActionSetConcedente", res.data.concedente);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.concedentes.store(payload).then((res) => {
    commit(types.SET_CONCEDENTE, res.data.concedente);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.concedentes.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_CONCEDENTE, res.data.concedente);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.concedentes.delete({ id: id }).then(() => {
    commit(types.SET_CONCEDENTE, null);
  });
};

export const ActionSetConcedentes = ({ commit }, payload) => {
  commit(types.SET_CONCEDENTES, payload);
};

export const ActionSetConcedente = ({ commit }, payload) => {
  commit(types.SET_CONCEDENTE, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNew = ({ commit }) => {
  commit(types.SET_CONCEDENTE, {
    concedente_tipo_id: null,
    nome: "",
    tax_id: "",
    sobre: "",
    site: "",
    sem_endereco: false,
    endereco: endereco_empty(),
    contatos: contatos_empty(),
    logo: null,
    imagem: null,
  });
};

export const ActionVerifyNome = async (store, payload) => {
  var concedentes = [];

  if (payload.nome) {
    await services.concedentes.verify_nome(payload).then(({ data }) => {
      concedentes = data;
    });
  }
  return concedentes;
};
